export default "__VITE_ASSET__lyuL5R88__"